const initialState = {
  loading: false
};

const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOADER_START":
      return { loading: true };
    case "LOADER_STOP":
      return { loading: false };
    default:
      return state;
  }
};

export default loaderReducer;
